import React from 'react';

import { ReactComponent as FlagBD } from '@assets/icons/flag/bd.svg';
import { ReactComponent as FlagGermany } from '@assets/icons/flag/germany.svg';
import { ReactComponent as FlagSpain } from '@assets/icons/flag/spain.svg';
import { ReactComponent as FlagTurkey } from '@assets/icons/flag/turkey.svg';
import { ReactComponent as FlagUK } from '@assets/icons/flag/uk.svg';
import { ReactComponent as FlagUSA } from '@assets/icons/flag/us.svg';

const CountryFlag = ({ countryId }) => {
	return (
		<>
			{parseInt(countryId) === 16 && <FlagBD />}
			{parseInt(countryId) === 194 && <FlagSpain />}
			{parseInt(countryId) === 237 && <FlagTurkey />}
			{parseInt(countryId) === 242 && <FlagUSA />}
			{parseInt(countryId) === 243 && <FlagUK />}
			{parseInt(countryId) === 74 && <FlagGermany />}
		</>
	);
};
export default CountryFlag;
